<template>
    <section class="c-container">
        <div class="c-filters-clear">
            <p class="c-filters-clear__title">Showing results for: <span class="c-filters-clear__title--results"> {{ filterText }} </span></p>
            <a class="c-filters-clear__clear-btn c-btn c-btn--secondary" href="#" @click="clearFilters">Clear Filters
                <i class="fas fa-times" aria-hidden="true" ></i>
            </a>
        </div>
    </section>
</template>

<script>
    import {EventBus} from "../event-bus"
    export default {
        name: "FilterOutput",
        props: ['filterText'],
        methods: {
            clearFilters() {
                EventBus.$emit('clearFilters')
            }
        },
    }
</script>

<style>

</style>
